<template>
  <div class="bg-image">

    <div class="container padded bg-danger-lighten-2" style="opacity: 90%; border-radius: 20px; margin-top: 1.74em; margin-bottom: 1.74em;">
      <div v-if="!successReg || !failReg">

      <h2>Register</h2>
      <el-row v-if="!newSystem">
        <el-col :xs="24" :sm="24" :md="12" :lg="16">

          <template v-if="metaError">
            <el-alert
            type="error"
            show-icon
            :closable="false"
            title="Couldn't load organisation categories"
            description="We couldn't reach the registration service. Please try again." />
            <el-button type="text" @click="loadMetadata">Retry</el-button>
          </template>

          <template v-else-if="metaLoading">
            <i class="el-icon-loading"></i>&nbsp;Loading categories&hellip;
          </template>

          <select-org-category v-else v-model="cat" no-form :list="orgCategories" />

        </el-col>

        <el-col :xs="24" :sm="12" :md="6" :lg="4">
          <check-box v-if="cat" style="padding-top: 1.528em; margin-left: 1em;" v-model="existing" no-form :disabled="!cat">Existing</check-box>
        </el-col>

      </el-row>

      <p />
      <el-row v-if="cat" :gutter="10" justify="center">

        <el-col v-if="existing" :xs="24" :sm="24" :md="24" :lg="24">

          <el-select
          v-model="contact.organisation"
          filterable
          remote
          value-key="id"
          :remote-method="findRegOrgs"
          :loading="orgLoading"
          placeholder="Type at least 3 characters to search&hellip;"
          no-data-text="Type at least 3 characters to search"
          no-match-text="No matching organisations"
          loading-text="Searching&hellip;"
          style="width: 100%;">

            <el-option
              v-for="org in orgSearchResults"
              :key="org.id"
              :label="org.name"
              :value="org">
              <span style="float: left">{{ org.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">
                {{ org.shortName }}
              </span>
            </el-option>

          </el-select>

          <small v-if="orgSearchResults.length === 20" class="text-muted">Showing the first 20 matches &mdash; keep typing to narrow your search.</small>

          <p />
          <el-button type="text" @click="existing = false">Can't find your organisation? Register a new one</el-button>

        </el-col>

        <el-col v-else :xs="24" :sm="24" :md="24" :lg="24">

          <!-- XOL-375: el-form wrapper required — el-form-item render-crashes
               without the elForm injection (Element 2.11 form-item reads
               elForm.$options during render). -->
          <el-form label-position="top">

          <el-row :gutter="16">
            <el-col :xs="24" :md="8">
              <el-form-item :label="cat + ' Name'">
                <el-input v-model="contact.organisation.name"
                  placeholder="Name">
                  <template #prepend><i class="fa fa-user"></i></template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="8">
              <el-form-item label="Short Name">
                <el-input v-model="contact.organisation.shortName"
                  placeholder="Short Name">
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="8">
              <el-form-item label="Registration No">
                <el-input v-model="contact.organisation.registrationNo"
                  placeholder="Registration No.">
                  <template #prepend><i class="fa fa-id-badge"></i></template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Address">
            <el-input type="textarea" :rows="3"
              v-model="contact.organisation.address"
              placeholder="Address">
              <template #prepend><i class="fa fa-home"></i></template>
            </el-input>
          </el-form-item>

          <el-row :gutter="16">
            <el-col :xs="24" :md="8">
              <el-form-item label="Post Code">
                <el-input v-model="contact.organisation.postCode"
                  placeholder="Post Code">
                  <template #prepend><i class="fa fa-barcode"></i></template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="8">
              <el-form-item label="Phone">
                <el-input type="phone" v-model="contact.organisation.phone"
                  placeholder="Phone">
                  <template #prepend><i class="fa fa-phone"></i></template>
                </el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :md="8">
              <el-form-item label="E-Mail">
                <el-input type="email" v-model="contact.organisation.email"
                  placeholder="E-Mail">
                  <template #prepend><i class="fa fa-envelope"></i></template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="Web Site">
            <el-input v-model="contact.organisation.website"
              placeholder="Web Site">
              <template #prepend><i class="fa fa-globe"></i></template>
            </el-input>
          </el-form-item>

          </el-form>

          <el-button type="text" @click="existing = true">Use an existing organisation instead</el-button>

        </el-col>

      </el-row>

      <p />

      <h2 v-if="contact.organisation && contact.organisation.name"><small>{{cat}}:&nbsp;</small>{{contact.organisation.name}}</h2>

      <el-form inline label-width="174px" v-if="contact.organisation && contact.organisation.name">
        <h4>Contact:</h4>
        <el-row>
          <text-input v-model="contact.name" label="Full Name" required />
          <text-input v-model="contact.shortName"  label="Short Name" />
          <text-input v-model="contact.jobTitle" label="Job Title" />

        </el-row>

        <el-row>
          <text-input type="phone" v-model="contact.phone"  label="Phone" />
          <text-input type="email" v-model="contact.email" label="E-mail" required />
        </el-row>

        <el-row :gutter="12">

          <el-col :span="24">
            <text-input label="Login Id" v-model="contact.login" />
          </el-col>

          <el-col :span="24">
            <el-form-item>
               <password-form v-model="contact" toggle />
           </el-form-item>

           <el-alert v-if="!passwordsMatch"
           title="Passwords Don't Match"
           description="Passwords must match, be at least 8 characters, and not contain your login name."
           show-icon
           type="error"
           :closable="false" />

          </el-col>

        </el-row>

        <el-row>

          <el-col :span="12">
            <check-box label="E-mail Upload Alerts" v-model="contact.sendUploadAlerts" />
          </el-col>

          <el-col :span="12">
            <check-box label="E-mail Approval Alerts" v-model="contact.sendApprovalAlerts" />
          </el-col>

        </el-row>

      </el-form>

      <center>
        <el-button type="text" @click="refreshBrowser()">&lt;&lt;&nbsp;Back</el-button>
        &nbsp;
        <el-button
        type="danger" @click="register"
        :disabled="!(contact.name && contact.email && contact.login && passwordsMatch && orgReady)">
        Register
      </el-button>
    </center>

  </div>
  <div>

    <div v-if="!newSystem && successReg">
      <center>Successful Registration - Wait for System Admin to approve registration</center>
    </div>

  </div>
</div>

</div>

</template>

<script>

import axios from '@/lib/axiosClient'

import PostMixins from '@/mixins/PostMixins'

import SelectOrgCategory from '@/components/atoms/selects/SelectOrgCategory'

import SelectAuthority from '@/components/atoms/selects/SelectAuthority'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'
import SelectInsurer from '@/components/atoms/selects/SelectInsurer'

import PasswordForm from '@/components/login/PasswordForm'

export default {

  mixins: [PostMixins],

  components: {
    SelectAuthority,
    SelectBackhaulProvider,
    SelectInsurer,
    SelectOrgCategory,
    PasswordForm
  },

  props: {

    newSystem: {
      type: Boolean,
      required: true,
  }
},

  watch: {
    orgId: function (oid) {
      this.orgId = oid
      this.contact.organisation_id = oid
      this.contact.organisation = null
    },

    cat: function (c) {
      this.orgId = null
      this.contact.organisation_id = null
      this.contact.organisation = this.emptyOrg()
      this.orgSearchResults = []
      this.cat = c
    },

    // XOL-375: switching between "join an existing org" and "register a
    // new one" must not leak the other mode's picked/typed org into the
    // submit payload.
    existing: function () {
      this.contact.organisation = this.emptyOrg()
      this.orgSearchResults = []
    }

  },


  computed: {
    passwordsMatch: function () {

      if (this.contact.password &&
        this.contact.c_password &&
        this.contact.password.length >= 8 &&
        !this.contact.password.includes(this.contact.login)) {
        return (this.contact.password === this.contact.c_password)
      }

    return false
    },

    // XOL-375: join mode needs a picked existing org (has an id); new-org
    // mode needs at least a typed name. Category is already required to
    // reach either mode (v-if="cat" above).
    orgReady: function () {

      if (this.newSystem) {
        return true
      }

      if (this.existing) {
        return !!(this.contact.organisation && this.contact.organisation.id)
      }

      return !!(this.contact.organisation && this.contact.organisation.name)
    }

  },

  methods: {

    // XOL-375: predeclare every key the new-org inline form v-models onto.
    // Vue 2 can't track reactivity on properties added after the object is
    // created, so a bare `{}` here means `contact.organisation.name` never
    // triggers the `v-if`/`orgReady` gates that depend on it.
    emptyOrg () {
      return {
        name: null,
        shortName: null,
        registrationNo: null,
        address: null,
        postCode: null,
        phone: null,
        email: null,
        website: null
      }
    },

    // XOL-375: anonymous callers can't reach GET /api/system/config (JWT
    // gated), so the register form's category options come from the
    // public GET /api/registration/metadata endpoint instead.
    loadMetadata () {
      this.metaLoading = true
      this.metaError = false

      axios.get(this.getEndpoint('registration/metadata'))
        .then(response => {
          this.orgCategories = response.data.orgCategories
          this.metaLoading = false
        })
        .catch(err => {
          console.error('Register: unable to load registration metadata', err)
          this.metaError = true
          this.metaLoading = false
        })
    },

    // XOL-375 decision 1 = A: filtered remote org search for the anonymous
    // register form, backed by GET /api/registration/orgs (category +
    // filter scoped, capped at 20, {id,name,shortName} projection only).
    // Deliberately a local method rather than a SiteMixins addition/edit -
    // the existing filterOrganisation() family is for authenticated pages.
    findRegOrgs (query) {
      var q = (query || '').trim()

      if (q.length < 3) {
        this.orgSearchResults = []
        return
      }

      this.orgLoading = true

      axios.get(this.getEndpoint('registration/orgs') + '?category=' + encodeURIComponent(this.cat) + '&filter=' + encodeURIComponent(q))
        .then(response => {
          this.orgSearchResults = response.data
          this.orgLoading = false
        })
        .catch(err => {
          console.error('Register: unable to search organisations', err)
          this.orgSearchResults = []
          this.orgLoading = false
        })
    },

    register () {

      if (this.newSystem) {

        this.contact.organisation_id = this.xolasClient().id
        this.contact.password   = this.contact.password.trim()
        this.contact.c_password = this.contact.c_password.trim()

        this.saveForm(this, '/register', null, this.contact, 'Register', this.succeed, this.fail)
        return
      }

      // XOL-375: POST /api/registration is an allow-list endpoint - never
      // spread the whole `contact` object (it would carry no role/enabled
      // fields today, but the allow-list is the contract, not an accident
      // of what happens to be on `contact`).
      var payload = {
        name: this.contact.name,
        shortName: this.contact.shortName,
        jobTitle: this.contact.jobTitle,
        phone: this.contact.phone,
        email: this.contact.email,
        login: this.contact.login,
        password: this.contact.password.trim(),
        c_password: this.contact.c_password.trim(),
        sendUploadAlerts: this.contact.sendUploadAlerts,
        sendApprovalAlerts: this.contact.sendApprovalAlerts
      }

      // Exactly one of organisation_id / organisation - never both.
      if (this.existing && this.contact.organisation && this.contact.organisation.id) {
        payload.organisation_id = this.contact.organisation.id
      } else {
        payload.organisation = {
          category: this.cat,
          name: this.contact.organisation.name,
          shortName: this.contact.organisation.shortName,
          registrationNo: this.contact.organisation.registrationNo,
          address: this.contact.organisation.address,
          postCode: this.contact.organisation.postCode,
          phone: this.contact.organisation.phone,
          email: this.contact.organisation.email,
          website: this.contact.organisation.website
        }
        this.pruneEmpty(payload.organisation)
      }

      // XOL-375: drop untouched optional fields — the API validates present
      // keys as strings, so an explicit null fails ("must be a string").
      this.pruneEmpty(payload)

      this.saveForm(this, '/registration', null, payload, 'Register', this.succeed, this.fail)
    },

    // XOL-375: remove null/empty-string keys in place so optional fields the
    // user never touched are absent from the payload rather than null.
    pruneEmpty (obj) {
      for (var key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key]
        }
      }
    },

    succeed (reg) {
      this.successReg = true
      this.failReg = false

      // XOL-375: join mode (and the newSystem bootstrap) keep the original
      // copy; new-org self-registration also creates an org pending
      // approval, so the message covers both.
      var message = (this.newSystem || this.existing)
        ? 'Please wait for the System Admin to approve your registration'
        : 'Your organisation and account have been submitted and await System Admin approval.'

      this.$alert(message,
                  'Successful Registration',
                  {
                    confirmButtonText: 'OK',
                    callback: action => {
                      this.refreshBrowser()
                }
              })
        },


    fail (errors) {
      this.successReg = false
      this.failReg = true
      console.error(errors)

      // XOL-375: duplicate new-org name — suggest joining the existing org
      // instead of just failing. Capture the typed name before switching to
      // "existing" mode, since that watcher resets contact.organisation.
      if (!this.newSystem && errors && errors['organisation.name']) {
        var typedName = this.contact.organisation && this.contact.organisation.name

        this.$alert("An organisation with this name already exists — try searching for it under 'Existing'.",
                    'Organisation already exists',
                    {
                      confirmButtonText: 'OK',
                      callback: action => {
                        this.existing = true
                        this.$nextTick(() => {
                          this.findRegOrgs(typedName)
                        })
                  }
                })
        return
      }

      this.$alert('Something went wrong with your registration.',
                  'Failed  Registration',
                  {
                    confirmButtonText: 'OK',
                    callback: action => {
                      // XOL-375: a reload would wipe whatever the customer
                      // just typed. Only the newSystem bootstrap flow (which
                      // has no form data worth preserving) reloads on fail.
                      if (this.newSystem) {
                        this.refreshBrowser()
                      }
                }
              })
    }
  },


data () {
  return {
    existing: true,
    metaLoading: !this.newSystem,
    metaError: false,
    orgCategories: [],
    orgSearchResults: [],
    orgLoading: false,
    message: null,
    successReg: false,
    failReg: false,
    orgId: (this.newSystem ? this.xolasClient().id : null),
    cat: null,
    contact: (this.newSystem ? {
      enabled: true,
      login: null,
      shortName: null,
      defaultView: 'admin',
      name: null,
      password: null,
      c_password: null,
      allowedHost: this.getStore().hostname,
      super: true,
      userRole: 'project|maintenance|property|finance|admin',
      organisation: this.xolasClient()
    } : {
      login: null,
      shortName: null,
      jobTitle: null,
      name: null,
      phone: null,
      email: null,
      password: null,
      c_password: null,
      allowedHost: this.getStore().hostname,
      sendUploadAlerts: false,
      sendApprovalAlerts: false,
      organisation: this.emptyOrg()
    })
  }
},

created () {
  if (!this.newSystem) {
    this.loadMetadata()
  }
}


}

</script>

<style scoped>

.pad-top {
  padding-top: 1.5em;
  padding-left: 0.5em;
}

.bg-image {

  width: 100%;

  background: url('/static/login/background.jpg') no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
}



</style>
